import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reduceCancellationResult } from '../../actions/policy/reduceCancellationResult';
import { getPolicySaga } from './getPolicySaga';
import { getPolicySummarySaga } from './getPolicySummarySaga';

export function* updateCancellationDateSaga(action) {
    try {
        yield put(reduceLoading({ code: 'updateCancellationDate', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyCancellation/update-effective-date', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: action.payload.policyTransactionGuid,
                cancellationDate: action.payload.cancellationDate,
            }),
        });

        const result = yield call([response, 'json']);
        yield put(reduceCancellationResult(result));
        yield put(reduceLoading({ code: 'updateCancellationDate', value: false }));

        if (result.operation?.status) {
            yield put(
                addNotification({
                    code: 'updateCancellationDate',
                    type: 'success',
                    message: action.payload.successMessage,
                }),
            );
            // Refresh in place so the transaction reflects the new effective date.
            yield getPolicySaga();
            yield getPolicySummarySaga();
        } else {
            yield put(
                addNotification({
                    code: 'updateCancellationDate',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }
    } catch (error) {
        console.log('Error while updating Cancellation date API - ', error);
        yield put(reduceLoading({ code: 'updateCancellationDate', value: false }));
        yield put(
            addNotification({
                code: 'updateCancellationDate',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
